export default __webpack_public_path__ + "static/media/CoinBottomSheet.87561411.svg";